import React from 'react'
import styles from './index.module.less'
import {useLocation } from 'react-router-dom'

export default function Loading() {
  const location = useLocation()
    // 定义需要显示Loading的页面路径
    const needLoadingPaths = ['/knowledge/treat-Img'];
  
    // 判断当前页面是否需要显示Loading
    const shouldShowLoading = needLoadingPaths.includes(location.pathname);
      
    return (
      <div className={shouldShowLoading?'':styles.loadingContainer} >
        
      </div>
    )
}
